import { useState } from 'react';
import { Dialog } from '@mui/material';
import { useTranslation } from '../hooks/useTranslation';

const RequestChangeModal = ({ isOpen, onClose, onSubmit }) => {
  const [comment, setComment] = useState('');

  const t = useTranslation();
  const handleSubmit = () => {
    onSubmit(comment);
    setComment('');
    onClose();
  };

  const handleClose = () => {
    setComment('');
    onClose();
  };

  return (
    <Dialog
      open={isOpen}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        style: {
          padding: '0px',
          border: '1px solid #ccc',
          borderRadius: '4px',
          background: '#fff',
          overflow: 'visible',
        },
      }}
    >
      <div style={styles.container}>
        <div style={styles.header}>
          <h2 style={styles.title}>{t('request_change')}</h2>
        </div>

        <div style={styles.body}>
          <p style={styles.description}>
            {t('describe_the_requested_process_change_to_be_send_to_the_process_modeler')}:
          </p>

          <textarea
            style={styles.textarea}
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            placeholder={t('the_user_can_add_a_message_to_the_process_modeler')}
          />
        </div>

        <div style={styles.footer}>
          <button style={styles.cancelButton} onClick={handleClose}>
            {t('Cancel')}
          </button>
          <button style={styles.submitButton} onClick={handleSubmit}>
            {t('request_change')}
          </button>
        </div>
      </div>
    </Dialog>
  );
};

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    padding: '20px',
  },
  header: {
    borderBottom: 'none',
  },
  title: {
    margin: 0,
    color: '#002060', // Deep blue
    fontSize: '12px',
    fontWeight: '600',
  },
  body: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
  },
  description: {
    color: '#002060', // Deep blue
    fontSize: '12px',
    fontWeight: '300',
    marginBottom: '5px',
    marginTop: '5px',
  },
  textarea: {
    width: '100%',
    minHeight: '200px',
    padding: '10px',
    fontSize: '12px',
    borderRadius: '0', // Sharp edges as per screenshot
    resize: 'vertical',
    outline: 'none',
    boxSizing: 'border-box',
  },
  footer: {
    display: 'flex',
    justifyContent: 'space-between',
    paddingTop: '15px',
  },
  cancelButton: {
    backgroundColor: '#002060', // Dark blue/black as per screenshot
    color: '#fff',
    border: 'none',
    padding: '10px 20px',
    fontSize: '12px',
    borderRadius: '5px',
    cursor: 'pointer',
    fontWeight: '300',
  },
  submitButton: {
    backgroundColor: '#002060', // Same blue for consistency or match specific blue
    color: '#fff',
    border: 'none',
    padding: '10px 20px',
    fontSize: '12px',
    borderRadius: '5px',
    cursor: 'pointer',
    fontWeight: '300',
  },
};

export default RequestChangeModal;
